<template>
  <div class="opera-homePageHuanQiu">
    <div class="hdfix"
         :class="{hd2:topMsg.v}">
      <div class="header">
        <span>{{ homeUserInfo.hotelName }}</span>
        <div class="topMsg"
             v-if="topMsg.v">
          <a v-if="topMsg.url && topMsg.url.indexOf('http') == 0"
             @click="openUrl(topMsg.url)">{{ topMsg.msg | flength }}</a>
          <router-link :to="topMsg.url"
                       v-else-if="topMsg.url">{{ topMsg.msg | flength }}>>
          </router-link>
          <template v-else>{{ topMsg.msg | flength }}</template>
          <div class="cleartext"
               @click="closeTopMsg">
            <i class="iconfont icon-cuowu"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="body-container">
      <div class="big-panel">
        <div class="big-panel-title">大房概览
          <span class="sub-title">(间)</span>
        </div>

        <div class="spe-big-panel-body">
          <div class="item-list">
            <div class="data-item" @click="goSearchPage('DI', '脏房')">
              <div class="item-circle" style="border-color: red"></div>
              <div class="item-info">
                <div class="item-name">脏房</div>
                <div class="item-number">{{ bigRoom.diNum }}</div>
              </div>
            </div>
            <div class="data-item" @click="goSearchPage('CL', '干净')">
              <div class="item-circle" style="border-color: deepskyblue"></div>
              <div class="item-info">
                <div class="item-name">干净</div>
                <div class="item-number">{{ bigRoom.clNum }}</div>
              </div>
            </div>
            <div class="data-item" @click="goSearchPage('IP', '检查')">
              <div class="item-circle" style="border-color: green"></div>
              <div class="item-info">
                <div class="item-name">检查</div>
                <div class="item-number">{{ bigRoom.ipNum }}</div>
              </div>
            </div>
          </div>
          <div class="item-list center-item">
            <div class="data-item" @click="goSearchPage('OCC', '占用')">
              <div class="item-circle" style="border-color: #aaa"></div>
              <div class="item-info">
                <div class="item-name">占用</div>
                <div class="item-number">{{ bigRoom.occNum }}</div>
              </div>
            </div>
            <div class="data-item" @click="goSearchPage('VAC', '空房')">
              <div class="item-circle" style="border-color: #aaa"></div>
              <div class="item-info">
                <div class="item-name">空房</div>
                <div class="item-number">{{ bigRoom.vacNum }}</div>
              </div>
            </div>
          </div>
          <div class="item-list" style="width: 33%">
            <div class="data-item" @click="goSearchPage('OO', '大修')">
              <div class="item-circle" style="border-color: #aaa"></div>
              <div class="item-info">
                <div class="item-name">大修</div>
                <div class="item-number">{{ bigRoom.ooNum }}</div>
              </div>
            </div>
            <div class="data-item" @click="goSearchPage('OS', '小修')">
              <div class="item-circle" style="border-color: #aaa"></div>
              <div class="item-info">
                <div class="item-name">小修</div>
                <div class="item-number">{{ bigRoom.osNum }}</div>
              </div>
            </div>
            <div class="data-item" @click="goSearchPage('CL,DI', '待打扫')">
              <div class="item-circle" style="border-color: #aaa"></div>
              <div class="item-info">
                <div class="item-name">待清扫</div>
                <div class="item-number">{{ bigRoom.toCleanedNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="big-panel">
        <div class="big-panel-title">客房状态
          <span class="sub-title">(间)</span>
        </div>
        <div class="big-panel-body">
          <div class="item-list">
            <div class="data-item-big">
              <img src="../../assets/images/huanQiuImg/B@2x.png" class="item-img"/>
              <div class="item-info">
                <div class="item-number">{{ guestRoom.arrivalsActualRoom }}</div>
                <div class="item-name">今日实际抵店</div>
              </div>
            </div>
            <div class="data-item-big clickable" @click="goSearchPage('DUEIN','今日预计抵店')">
              <img src="../../assets/images/huanQiuImg/A@2x.png" class="item-img"/>
              <div class="item-info">
                <div class="item-number">{{ guestRoom.arrivalsExpectedRoom }}</div>
                <div class="item-name">今日预计抵店</div>
              </div>
            </div>
          </div>

          <div class="item-list">
            <div class="data-item-big">
              <img src="../../assets/images/huanQiuImg/D@2x.png" class="item-img"/>
              <div class="item-info">
                <div class="item-number">{{ guestRoom.departuresActualRoom }}</div>
                <div class="item-name">今日实际离店</div>
              </div>
            </div>
            <div class="data-item-big clickable" @click="goSearchPage('DUEOUT', '今日预计离店')">
              <img src="../../assets/images/huanQiuImg/C@2x.png" class="item-img"/>
              <div class="item-info">
                <div class="item-number">{{ guestRoom.departuresExpectedRoom }}</div>
                <div class="item-name">今日预计离店</div>
              </div>
            </div>
          </div>

          <div class="item-list">
            <div class="data-item-big">
              <img src="../../assets/images/huanQiuImg/E@2x.png" class="item-img"/>
              <div class="item-info">
                <div class="item-number">{{ guestRoom.avl }}</div>
                <div class="item-name">今日可用房</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <foot-nav sta='1'></foot-nav>
  </div>
</template>
<script>
  import myList from "../operaCommon/myList";
  import footNav from "../operaCommon/huanQiufootNav";
  import homeData from "../operaCommon/homeData";
  import {Toast, MessageBox} from "mint-ui";

  export default {
    data() {
      return {
        topStatus: "",
        homeUserInfo: {},
        topMsg: {v: false, msg: "", type: "msg", link: ""},
        bigRoom: {},
        guestRoom: {}
      };
    },
    mounted() {
      this.getHomeUserInfo();
      this.getHomeData();
      var that = this;
      window.showTopMsg = this.showTopMsg;
      window.setTimeout(function () {
        that.versionMsg();
      }, 2000);
    },
    methods: {
      goSearchPage(type, title){
        this.$router.push('/opera/indexFangTDetail?title=' + title + '&type=' + type)
      },
      getHomeUserInfo() {
        this.$http.get("/mobilepmsapi/sys/getHomeUserInfo").then(res => {
          if (res.data.result == 0) {
            this.homeUserInfo = res.data.retVal;
          }
        });
      },
      getHomeData() {
        const self = this
        this.$http.post("/mobilepmsapi/opera/biz/getHomeInfoForHuanQiu").then(res => {
          if (res.data.result == 0) {
            var retVal = res.data.retVal || {};
            self.bigRoom = retVal.bigRoom || {}
            self.guestRoom = retVal.guestRoom || {}
          }
        });
      },

      versionMsg() {
        if (this.$isApp) {
          this.waitReady();
        } else {
          if (
            localStorage.getItem("version") == null ||
            localStorage.getItem("version") != this.pversion
          ) {
            localStorage.setItem("version", this.pversion);
            this.showTopMsg(
              this.pversion + this.$t('index_new_version'),
              "msg",
              "/versionDetail?redirect=/opera/indexHuanQiu"
            );
          }
        }
      },
      plusReady() {
        var c = plus.storage;
        if (
          c.getItem("version") == null ||
          c.getItem("version") != this.pversion
        ) {
          c.setItem("version", this.pversion);
          this.showTopMsg(
            this.pversion + this.$t('index_new_version'),
            "msg",
            "/versionDetail?redirect=/opera/indexHuanQiu"
          );
        } else {
          var A = plus.webview.getLaunchWebview();
          A.evalJS("disPushMsg()");
        }
      },
      waitReady() {
        if (window.plus) {
          this.plusReady();
        } else {
          document.addEventListener("plusReady", this.plusReady, false);
        }
      },
      showTopMsg(msg, type, url) {
        this.topMsg = {
          msg: msg,
          v: true,
          type: type,
          url: url && url.indexOf("#") == 0 ? url.substr(1) : url
        };
      },
      closeTopMsg() {
        this.topMsg.v = false;
        if (this.topMsg.type == "push") {
          var A = plus.webview.getLaunchWebview();
          A.evalJS("clearPushMsg()");
        } else {
          if (this.$isApp) {
            var A = plus.webview.getLaunchWebview();
            A.evalJS("disPushMsg()");
          }
        }
      },
      msg(msg) {
        Toast({message: msg, position: "bottom", duration: 3000});
      },
      loadTop() {
        this.disHomeData();
        this.$refs.loadmore.onTopLoaded();
      },
    },
    filters: {
      flength(value) {
        return value.length > 30 ? value.substr(0, 28) + ".. " : value;
      }
    },
    components: {
      myList,
      footNav,
      homeData
    }
  };
</script>
<style lang='less' scoped>
  .opera-homePageHuanQiu {
    overflow: auto;

    .body-container {
      background: #efefef;
      padding: 15px;
      padding-bottom: 100px;
      height: 100vh;
      overflow-y: auto;
      box-sizing: border-box;

      .big-panel {
        background: #fff;
        border-radius: 8px;
        margin-bottom: 15px;
        padding: 15px;

        .big-panel-title {
          font-size: 20px;
          color: #333333;
          margin-bottom: 25px;

          .sub-title {
            font-size: 14px;
            color: #999;
          }
        }

        .big-panel-body {
          .item-list {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .data-item {
              width: 33%;
              display: flex;
              align-items: center;

              &:active{
                background: #ddd;
              }

              .item-circle {
                width: 15px;
                height: 15px;
                border-radius: 20px;
                border: 4px solid red;
                margin-right: 5px;
              }

              .item-info {
                .item-name {
                  font-size: 13px;
                  color: #333;
                }

                .item-number {
                  font-size: 18px;
                  color: #333;
                }
              }
            }


            .data-item-big {
              width: 50%;
              display: flex;
              align-items: center;
              padding: 10px;
              border-radius: 8px;
              &.clickable{
                &:active{
                  background: #ddd;
                }
              }
              .item-img {
                width: 40px;
                height: 40px;
                margin-right: 10px;
              }

              .item-number {
                font-size: 18px;
                color: #333;
              }

              .item-name {
                font-size: 10px;
                color: #333;
              }
            }
          }
        }

        .spe-big-panel-body {
          overflow: hidden;
          position: relative;

          .item-list {
            width: 33%;
            float: left;
            display: inline-block;
            box-sizing: border-box;

            .data-item {
              padding: 10px;
              width: 100%;
              display: flex;
              align-items: center;
              box-sizing: border-box;
              border-radius: 5px;
              &:active{
                background: #ddd;
              }

              .item-circle {
                width: 15px;
                height: 15px;
                border-radius: 20px;
                border: 3px solid red;
                margin-right: 8px;
                display: inline-block;
                flex: none;
              }

              .item-info {
                display: inline-block;
                .item-name {
                  font-size: 13px;
                  color: #333;
                  margin-bottom: 5px;
                }

                .item-number {
                  font-size: 18px;
                  color: #333;
                }
              }
            }


            .data-item-big {
              width: 50%;
              display: flex;
              align-items: center;

              .item-img {
                width: 40px;
                height: 40px;
                margin-right: 10px;
              }

              .item-number {
                font-size: 18px;
                color: #333;
              }

              .item-name {
                font-size: 10px;
                color: #333;
              }
            }
          }
        }
      }
    }


    .hdfix {
      height: 1.066667rem;

      .header {
        height: 1.066667rem;
        background-color: #393c41;
        position: fixed;
        width: 100%;
        z-index: 2;

        .right {
          position: absolute;
          right: 0.3rem;
          top: 0;
          color: #fff;

          i {
            font-size: 0.6rem;
            line-height: 1.066667rem;
          }

          /* div{font-size:0.32rem;transform:scale(0.6);position: absolute;top:0.6rem;left:0.14rem}*/
        }

        span {
          font-size: 0.4rem;
          width: 75%;
          display: block;
          margin: 0 auto;
          text-align: center;
          color: #fff;
          line-height: 1.066667rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }

    .hd2 {
      height: 1.94rem;
    }

    .topMsg {
      color: #6c6500;
      height: 0.9rem;
      width: 100%;
      background: #f6ef8b;
      line-height: 0.9rem;
      padding-left: 0.3rem;
      margin-top: -2px;

      a {
        color: #6c6500;
      }

      .cleartext {
        float: right;
        padding-right: 0.3rem;
        margin-top: -0.01rem;

        i.icon-cuowu {
          line-height: 0.32rem;
          background-color: #cabc00;
          border-radius: 50%;
          font-size: 0.32rem;
          text-align: center;
          color: #fff;
          padding: 0.13rem;
          -webkit-transform-origin-x: 0;
          transform: scale(0.6);
          -webkit-transform: scale(0.6);
          width: 0.32rem;
          display: inline-block;
        }
      }
    }
  }

</style>




// WEBPACK FOOTER //
// indexHuanQiu.vue?1eb224d1